module.exports = __webpack_public_path__ + "files/19cdcc92a506be99b96144f7482486f0.png";